import { render } from "./product_reviews.vue?vue&type=template&id=5d38167c"
import script from "./product_reviews.vue?vue&type=script&lang=js"
export * from "./product_reviews.vue?vue&type=script&lang=js"

import "./product_reviews.vue?vue&type=style&index=0&id=5d38167c&lang=css"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__